import {SubFlowType} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-compiled-sub-panel/digital-signage-compiled-sub-panel.types';
import type {DigitalSignageProviderSubFlow} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.types';

interface DigitalSignageProviderDescriptor {
  labelKey: string;
  iconName: string;
  imgSrc?: string;
  gaType: string;
}

/**
 * Presentation contract for every signage provider, shared by the signage list and the Recommended section's deep-link tiles so the two surfaces can never drift.
 */
export const DIGITAL_SIGNAGE_PROVIDER_DESCRIPTORS: Record<DigitalSignageProviderSubFlow, DigitalSignageProviderDescriptor> = {
  [SubFlowType.SMART_TV_SUBDISPLAY]: {
    labelKey: 'pmwjs_play_on_smart_tv',
    iconName: 'icon-tv',
    gaType: 'PlayOnSmartTV',
  },
  [SubFlowType.RAYDIANT_SUBDISPLAY]: {
    labelKey: 'pmwjs_raydiant',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-displai.png',
    gaType: 'Displai',
  },
  [SubFlowType.SCREEN_CLOUD_SUBDISPLAY]: {
    labelKey: 'pmwjs_screencloud',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-screencloud.png',
    gaType: 'ScreenCloud',
  },
  [SubFlowType.SIGNAGELIVE_WIDGET_SUBDISPLAY]: {
    labelKey: 'pmwjs_signagelive_widget',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-signagelive.png',
    gaType: 'SignageLive',
  },
  [SubFlowType.POSTERBOOKING_SUBDISPLAY]: {
    labelKey: 'pmwjs_posterbooking',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-poster-booking.png',
    gaType: 'PosterBooking',
  },
  [SubFlowType.FUGO_SUBDISPLAY]: {
    labelKey: 'pmwjs_fugo',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-fugo.png',
    gaType: 'Fugo',
  },
  [SubFlowType.YODECK_SUBDISPLAY]: {
    labelKey: 'pmwjs_yodeck',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-yodeck.png',
    gaType: 'Yodeck',
  },
  [SubFlowType.CLEAR_DIGITAL_SHO_SUBDISPLAY]: {
    labelKey: 'pmwjs_clear_digital_sho',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-clear-digital-sho.png',
    gaType: 'Clear Digital Sho',
  },
  [SubFlowType.VIZROM_SUBDISPLAY]: {
    labelKey: 'pmwjs_vizrom',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-vizrom.png',
    gaType: 'Vizrom',
  },
  [SubFlowType.DRIPBOARDS_SUBDISPLAY]: {
    labelKey: 'pmwjs_dripboards',
    iconName: 'icon-share-external',
    imgSrc: 'publishing-dripboards.png',
    gaType: 'Dripboards',
  },
};

/**
 * Providers offered in the signage list, in display order — also the only ones eligible for a Recommended deep-link tile. Disabled providers (Vizrom, DripBoards) keep their descriptors above but are omitted here.
 */
export const ACTIVE_DIGITAL_SIGNAGE_PROVIDERS: readonly DigitalSignageProviderSubFlow[] = [
  SubFlowType.SMART_TV_SUBDISPLAY,
  SubFlowType.RAYDIANT_SUBDISPLAY,
  SubFlowType.SCREEN_CLOUD_SUBDISPLAY,
  SubFlowType.SIGNAGELIVE_WIDGET_SUBDISPLAY,
  SubFlowType.POSTERBOOKING_SUBDISPLAY,
  SubFlowType.FUGO_SUBDISPLAY,
  SubFlowType.YODECK_SUBDISPLAY,
  SubFlowType.CLEAR_DIGITAL_SHO_SUBDISPLAY,
];
